import React from 'react';

export default function LoveCss() {
    return (
        <span className="css-fan">
            (I love styling. Huge CSS fan)
        </span>
    );
}
